'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = memoizeLast;

var _lodash = require('lodash');

/**
 * Returns a memoized version of f that uses the following memoization strategy:
 *  - Only caches the most recent result of calling f.
 *  - Compares inputs to f with the previous inputs to f using === comparison
 *    (except NaN, for which it considers NaN to be equal to NaN) across all
 *    arguments.
 * @param {function} f The function to memoize.
 * @return {function} The memoized function.
 */
function memoizeLast(f) {
  var prevResult = null;
  var prevArgs = null;

  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (prevArgs) {
      // Compare each arg to each prevArg that's in the same ordinal position.
      // If every comparison is equal, args are the same as prevArgs.
      var argsAreSame = (0, _lodash.every)((0, _lodash.zipWith)(args, prevArgs, function (a, b) {
        return (
          // We use lodash's isNaN instead of the built-in because the built-in
          // isNaN returns true for anything that can't parse to a number, and
          // we're only interested in actual NaN values.
          a === b || (0, _lodash.isNaN)(a) && (0, _lodash.isNaN)(b)
        );
      }));

      if (argsAreSame) {
        return prevResult;
      }
    }

    prevArgs = args;
    prevResult = f.apply(undefined, args);
    return prevResult;
  };
};
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/@chartbeat/light-side/lib/components/util/memoize-last.js
// module id = 152
// module chunks = 0